import { empty } from 'patronum';
import { createPromocodeRegistryModel } from 'entities/promocode';
import { authorizedVoucherRoute } from 'shared/routing';

const $voucherId = authorizedVoucherRoute.$params.map(({ id }) => id ?? null);

const promocodeRegistryModel = createPromocodeRegistryModel({
	$voucherId,
	disabled: empty($voucherId),
	onUpdate: [$voucherId],
});

export const voucherPagePromocodeModel = {
	promocodeRegistryModel,
};
